import { useState } from 'react';

import { Button } from '@app/components';

// admin-dashboard-opdracht.md §5: "De hoofdgrafieken krijgen een knop 'toon als tabel' - tegelijk
// toegankelijkheidsvangnet en de snelste manier om een getal te controleren dat er raar uitziet."
export function useChartTable() {
  const [showTable, setShowTable] = useState(false);

  const toggleButton = (
    <Button variant="outlined" color="gray" size="small" onClick={() => setShowTable((v) => !v)}>
      {showTable ? 'Toon als grafiek' : 'Toon als tabel'}
    </Button>
  );

  return { showTable, toggleButton };
}
